import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { FieldBooksService } from '../../../services/field-books/field-books.service';
import { CommonFunctionsService } from '../../../services/common-functions.service';
import { NullLiteral } from 'typescript';

@Component({
  selector: 'app-field-book-logs',
  imports: [
    CommonModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelect,
    MatOption,
    MatDatepickerModule,
    MatTableModule,
    MatIconModule
  ],
  templateUrl: './field-book-logs.component.html',
  styleUrl: './field-book-logs.component.css'
})
export class FieldBookLogsComponent implements OnInit {
  form: FormGroup;
  displayedColumns: string[] = ['officeName', 'requestorEmail', 'dateAssigned', 'fieldBookNumber'];
  dataSource = new MatTableDataSource<any>();
  searchConducted = false;
  isLoading = false;

  constructor(private fb: FormBuilder, private fieldBooksService: FieldBooksService, public commonFunctionsService: CommonFunctionsService) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      requestorEmail: [null],
      office: [null],
      startDate: [null],
      endDate: [null],
    });
  }

  onSubmit(): void {
    this.searchConducted = true;
    this.isLoading = true;

    // Clear the table data before a new search
    this.dataSource.data = [];

    if (this.form.valid) {
      const { requestorEmail, office, startDate, endDate } = this.form.value;

      this.fieldBooksService.getFieldBookLogs(requestorEmail, office, startDate, endDate).subscribe({
        next: (results: any) => {
          this.dataSource.data = results.data;
        },
        error: (err) => {
          console.error(err);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }

  refreshData(): void {
    this.dataSource.data = [];
    this.form.reset();
    this.searchConducted = false;
    this.isLoading = false;
  }
}
